import { ReactNode } from 'react'
import { MediaOwnerListItemBase } from './media-owner-list-item-base'
import { WappAvatar } from '$common/avatar'
import { useWapp } from '$logic/wapps/react-hook'
import { UserListItemSkeleton } from '$common/user-list-item'
import { AvatarSize } from '$common/avatar/avatar-base/types.ts'

interface Props {
  wappId: string
  secondaryText: string
  secondaryActionComponent: ReactNode
}

export function MediaWappListItem({
  wappId,
  secondaryText,
  secondaryActionComponent,
}: Props) {
  const { entity: wapp, loading: wappLoading } = useWapp(wappId)

  if (wappLoading || !wapp) return <UserListItemSkeleton />

  return (
    <MediaOwnerListItemBase
      primaryText={wapp.name}
      secondaryText={secondaryText}
      avatarComponent={<WappAvatar wappId={wappId} size={AvatarSize.MD} />}
      secondaryActionComponent={secondaryActionComponent}
      isTransparent
    />
  )
}
